import React from 'react';
import { motion } from 'framer-motion';
import { Download, BookOpen, Truck } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: <Download className="w-10 h-10 text-amber-500" data-id="element-107" />,
    num: '1',
    text: "Descarga la guía 'El Atajo' en tu celular o computadora."
  }, {
    icon: <BookOpen className="w-10 h-10 text-amber-500" data-id="element-108" />,
    num: '2',
    text: 'Estudia los patrones RAM de palabras clave por 7 días.'
  }, {
    icon: <Truck className="w-10 h-10 text-amber-500" data-id="element-109" />,
    num: '3',
    text: 'Agenda tu cita en el DMV y aprueba el examen en el primer intento usando nuestro sistema de descarte rápido.'
  }];
  return <section className="py-24 bg-slate-900 px-4 sm:px-6 lg:px-8" data-id="element-110">
      <div className="max-w-6xl mx-auto" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-112">
          <h2 className="text-4xl md:text-5xl font-oswald font-bold text-white uppercase mb-4" data-id="element-113">
            Cómo Funciona
          </h2>
          <p className="text-xl text-slate-400" data-id="element-114">
            Tu licencia en 3 simples pasos
          </p>
        </motion.div>

        <div className="flex flex-col md:flex-row gap-8 relative" data-id="element-115">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-slate-800 -translate-y-1/2 z-0" data-id="element-116"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex-1 relative z-10" data-id="element-117">
              <div className="bg-slate-800 border border-slate-700 rounded-2xl p-8 text-center h-full flex flex-col items-center relative hover:border-amber-500/50 transition-colors" data-id="element-118">
                <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-10 h-10 bg-amber-500 text-slate-900 font-oswald font-bold text-xl rounded-full flex items-center justify-center border-4 border-slate-900" data-id="element-119">
                  {step.num}
                </div>
                <div className="bg-slate-900 p-5 rounded-full mb-6 mt-4" data-id="element-120">
                  {step.icon}
                </div>
                <p className="text-lg text-slate-300 leading-relaxed" data-id="element-121">
                  {step.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}